<ciwc-app-header></ciwc-app-header>

<div class="w-[90%] mx-auto py-8">
  <router-outlet></router-outlet>
</div>
